module.exports = __webpack_public_path__ + "static/Cristian-Abril-6635655f6550e16d4ca8c92a96bbe415.png";